import React, { useRef } from 'react';
import { CSSTransition } from 'react-transition-group';
import useOutsideClick from '../../utils/useOutsideClick';
import { ErrorIcon, SuccessIcon } from '../../Assets';
import useToaster from './useToaster';
import './toaster.scss';

const Toaster = () => {
  const {
    open,
    info: { type = 'success', text = '' },
    setOpen,
  } = useToaster();
  const ref = useRef();

  useOutsideClick(ref, () => {
    if (open) {
      setOpen(false);
    }
  });

  return (
    <div>
      <div ref={ref}>
        <CSSTransition
          appear
          in={open}
          timeout={400}
          classNames="slide"
          unmountOnExit
        >
          <div className="toaster">
            <div className={`icon-wrapper ${type}`}>
              {' '}
              <span>
                {type === 'success' && <SuccessIcon />}
                {type === 'error' && <ErrorIcon color="#ffffff" />}
              </span>
            </div>
            <div className="message">{text}</div>
          </div>
        </CSSTransition>
      </div>
    </div>
  );
};

export default Toaster;
